//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

import template from './pinterest-bookmarklet.html';

const bookmarklet = angular.module('bookmarklet', ['curalate']);

bookmarklet.component('pinterestBookmarklet', {
  template,
  controller: [
    '$log',
    '$scope',
    '$window',
    'BookmarkletService',
    'SchedulerService',
    'SessionVarsService',
    function (
      $log,
      $scope,
      $window,
      BookmarkletService,
      SchedulerService,
      SessionVarsService,
    ) {
      $scope.bookmarklet = {
        allImages: [],
        state: null,
      };

      function getParameterByName(name) {
        name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
        const results = regex.exec($window.location.search);
        return results === null
          ? ''
          : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }

      function addImageToLibrary(image, sourceUrl) {
        image.outstandingAsyncAction = 'AddImageToLibrary';
        return SchedulerService.addSavedImageUrlAsyncEx({
          imageUrl: image.imageUrl,
          sourceUrl,
          description: image.description,
          universalItemType: 'bookmarklet',
        })
          .then(() => {
            image.added = true;
          })
          .finally(() => {
            image.outstandingAsyncAction = null;
          });
      }

      const url = getParameterByName('url');

      $scope.bookmarklet.addedCount = function () {
        return _.filter($scope.bookmarklet.allImages, (i) => {
          return i.added === true;
        }).length;
      };

      $scope.bookmarklet.addToLibraryClicked = function (image) {
        image.showPinOrRepinUI = true;
      };

      $scope.bookmarklet.launchSchedulerClicked = function () {
        $window.open(`${$window.location.origin}/pinterest/schedule`);
      };

      $scope.bookmarklet.closeWindow = function () {
        $window.close();
      };

      $scope.bookmarklet.addAsPinClicked = function (image) {
        addImageToLibrary(image, image.sourceUrl ? image.sourceUrl : '');
      };

      $scope.bookmarklet.addAsRepinClicked = function (image) {
        addImageToLibrary(image, `http://www.pinterest.com/pin/${image.id}`);
      };

      $scope.bookmarklet.state = 'LoadingPins';
      BookmarkletService.getPinterestPinsForUrlAsync(url)
        .then((response) => {
          _.each(response, (pin) => {
            pin.added = false;
            pin.outstandingAsyncAction = null;
            pin.showPinOrRepinUI = false;

            $scope.bookmarklet.allImages.push(pin);
          });

          // Per design-review, shrink the window when only a single image is available
          // since the scrollbar is hidden.
          if ($scope.bookmarklet.allImages.length === 1) {
            $window.resizeTo(360, 609);
          }
          $scope.bookmarklet.state = 'Ready';
        })
        .catch((error) => {
          $log.error(error);
          $scope.bookmarklet.state = 'ErrorLoadingPins';
        });
    },
  ],
});

bookmarklet.service('BookmarkletService', [
  '$http',
  'PromiseService',
  function ($http, PromiseService) {
    this.getPinterestPinsForUrlAsync = function (url) {
      const promise = $http({
        method: 'GET',
        url: '/api/publish/pinterest-pins',
        params: {
          url,
        },
      });

      return PromiseService.processHttpResponse(promise);
    };
  },
]);
